/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `Browse and Discover Open Educational Resources`
};

const fr_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `Explorez et découvrez des ressources éducatives libres`
};

const de_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `Durchsuchen Sie Open Educational Resources`
};

const es_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `Explore y descubra recursos educativos abiertos`
};

const it_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `Sfoglia e scopri risorse educative aperte`
};

const ar_home_subtitle12 = /** @type {(inputs: {}) => string} */ () => {
	return `تصفح واكتشف الموارد التعليمية المفتوحة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_subtitle12 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_subtitle12(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_subtitle12", locale)
	if (locale === "en") return en_home_subtitle12(inputs)
	if (locale === "fr") return fr_home_subtitle12(inputs)
	if (locale === "de") return de_home_subtitle12(inputs)
	if (locale === "es") return es_home_subtitle12(inputs)
	if (locale === "it") return it_home_subtitle12(inputs)
	return ar_home_subtitle12(inputs)
};
export { home_subtitle12 as "HOME_SUBTITLE" }